import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { setactiveItem } from 'store/cards';
import Cookies from 'js-cookie';
import { usePopup } from 'hooks/usePopup';
import PlaceholderBlock from 'components/placeholder-blocks/PlaceholderBlock';
import PagePopopCloseButton from 'components/page-components/PagePopopCloseButton';
import Pagination from 'components/Pagination';
import CommonItemInfo from 'components/common-item/CommonItemInfo';
import CommonItemExpired from 'components/common-item/CommonItemExpired';

const CraftBuyItems = ({ cards, activeBlock, activeItem, offsetCount, setOffsetCount, paginationData, setMode }) => {
  const dispatch = useDispatch();
  const [searchInput, setSearchInput] = useState('');
  const [filteredItems, setFilteredItems] = useState([]);
  const setPopupHook = usePopup();
  const isBuyFromMarket = Cookies.get('isBuyFromMarket');

  const openPurchaseWindow = () => setPopupHook({type: 'purchase'});

  const closeMarketplaceMode = () => {
    setMode('select')
  }

  const searchHandler = (e) => {
    if (e.target.value.length === 0) {
      setFilteredItems(cards)
    } else {
      setFilteredItems(cards.filter((item) => item.name.toLowerCase().includes(e.target.value.toLowerCase())))
    }
  }

  useEffect(() => {
    setFilteredItems(cards);
    setSearchInput('')
  }, [cards, activeBlock]);

  useEffect(() => {
    if (!isBuyFromMarket) {
      setMode('select')
    }
  }, [isBuyFromMarket])

  return (
    <section className="craft-select">
      <h2 className="craft-block__title">Matching cards in marketplace</h2>
      <PagePopopCloseButton close={closeMarketplaceMode} />
      <form className="craft-select__form">
        <input type="text" className="craft-select__form-input" value={searchInput} onInput={(e) => {
          setSearchInput(e.target.value)
          searchHandler(e)
        }}
          placeholder={activeBlock}
        />
        <p className="craft-select__form-popup-wrapper">
          <button className="craft-select__form-filter" type='text'>Collection</button>
        </p>
        <p className="craft-select__form-popup-wrapper">
          <button className="craft-select__form-filter" type='text'>Rarity</button>
        </p>
        <p className="craft-select__form-popup-wrapper">
          <button className="craft-select__form-filter" type='text'>Status</button>
        </p>
      </form>
      {
        !filteredItems.length || filteredItems === null ?
          <PlaceholderBlock />
          :
          <ul className="cards-list__block cards-list__block--min">
            {
              filteredItems.map((item) => (
                <li
                  className={
                    `cards-list__block-item ${activeItem === item ? 'active' : ''} ${
                      item.type.toLowerCase() === 'event'
                        ? (item.is_valid_event === false ? 'cards-list__block-item--expired' : '')
                        : ''
                    }`
                  }
                  key={item.id}
                  onClick={() => dispatch(setactiveItem(item))}
                >
                  <CommonItemInfo name={item.name} type={item.type} image={item.image} props={item.properties} />
                  <p className="cards-list__block-item-text">{item.type.toLowerCase() === 'prize' ? '$' + item.name : item.name}</p>
                  <p className="cards-list__block-item-rarity">${item.cost}</p>
                  {item.type === 'Event' && item.is_valid_event === false && (<CommonItemExpired />)}
                  <button className="cards-list__block-item-button" onClick={openPurchaseWindow}>Buy now</button>
                </li>
              ))
            }
          </ul>
      }
      <Pagination offsetCount={offsetCount} setOffsetCount={setOffsetCount} paginationData={paginationData} />
    </section>
  )
}

export default CraftBuyItems
